<template>
  <el-container style="position: relative;">
    <el-drawer title="" direction="btt" :before-close="handleClose" :show-close="true" :visible.sync="drawerVisible">
      <div>
        <span>{{ this.bottomInfo.bottom.cookieText}}</span><br />
        <el-button class="cookieButton" @click="innerDrawer()">{{ this.bottomInfo.bottom.cookieButtonText}}</el-button>
      </div>
    </el-drawer>
    <el-aside class="pageMenulist imgShow" :class="{fold: isCollapse}">
      <el-row style="width:100%;">
        <el-col :xs="6" :sm="6" :md="24">
          <div class="logo" @click="indexClick">
            <img :src="logoUrl" width="100%" height="100%" />
          </div>
          <div class="phonelogo" @click="indexClick">
            <img :src="bottomInfo.base.logoUrl" width="100%" height="100%" />
          </div>
        </el-col>
        <!-- 语言和菜单 -->
        <el-col :xs="18" :sm="18" :md="24" class="imgShow" :class="{fold: isCollapse}">
          <div class="langMain">
            <el-button @click="toggleClick" type="text" class="langMainBtn">
              <a href="javascript:void(0)">
                <span class="iconfont icon-zhankai"></span>
              </a>
            </el-button>
            <div class="langSmallMain">
              <el-select v-model="langName" placeholder="请选择" @change="langSelectChange">
                <el-option :label="item.keyword" :value="item.name" v-for="(item, index) in bottomInfo.languages" :key="index">
                </el-option>
              </el-select>
            </div>
            <el-button type="text" class="langMainBtn" @click="searchClick">
              <a href="javascript:void(0)">
                <span class="iconfont icon-sousuo"></span>
              </a>
            </el-button>
            <div class="langName">
              <a href="javascript:void(0)">{{ langName }}</a>
            </div>
            <ul class="langMenuList">
              <li v-for="(item, index) in bottomInfo.languages" :key="index" @click="langChange(item)">
                <a :href="item.linkUrl" :title="item.name">{{item.keyword}}</a>
              </li>
            </ul>
          </div>
          <!--菜单-->
          <el-scrollbar>
            <el-menu class="el-menu-verstical-demo" :default-active="activeNav" :unique-opened="false" :collapse="isCollapse" mode="vertical">
              <template v-for="(item, index) in menuItem">
                <el-submenu :key="index" :index="'index' + index" v-if="item.childrens.length > 0">
                  <template slot="title" class="menuItem">
                    <span @click="handleSelect(item)"><i></i>{{ item.name }}</span>
                  </template>
                  <template>
                    <el-menu-item @click="handleSelect(tree)" v-for="(tree, i) in item.childrens" :key="i">
                      {{ tree.name }}
                    </el-menu-item>
                  </template>
                </el-submenu>
                <el-menu-item :index="'index' + index" :key="'index' + index" @click="handleSelect(item)" v-else>
                  <span slot="title"><i></i>{{item.name}}</span>
                </el-menu-item>
              </template>
            </el-menu>
          </el-scrollbar>
        </el-col>
      </el-row>
    </el-aside>
    <el-container class="pageContainer" :class="{fold: isCollapse}">
      <el-main style="width: auto;overflow:none">
        <router-view ref="router" :key="routerKey"></router-view>
      </el-main>
      <!-- 底部 -->
      <el-footer>
        <div class="indexContainer">
          <el-row class="footer">
            <el-col :xs="24" :sm="18" style="border-right: 1px solid #ccc;">
              <div class="footerMenu">
                <dl v-for="(item, index) in bottomNav" :key="index">
                  <dt @click="handleSelect(item)">
                    <a href="javascript:;">{{item.name}}</a>
                  </dt>
                  <dd v-for="(i, index2) in item.children" :key="index2" @click="handleSelect(i)">
                    <a href="javascript:;">{{i.name}}</a>
                  </dd>
                </dl>
              </div>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-row :gutter="20" class="footerWx">
                <el-col :xs="12" :sm="24">
                  <img :src="bottomInfo.bottom.officialQrcodeUrl || ''" alt="">
                  <p>{{bottomInfo.bottom.officialQrcodeText}}</p>
                </el-col>
                <el-col :xs="12" :sm="24">
                  <img :src="bottomInfo.bottom.serviceQrcodeUrl || ''" alt="">
                  <p>{{bottomInfo.bottom.serviceQrcodeText}}</p>
                </el-col>
                <el-col :xs="24">
                  <div class="footerMenu linkList">
                    <el-row>
                      <el-col :span="24" class="linksText">
                        {{bottomInfo.bottom.linksText}}
                      </el-col>
                      <el-col :xs="12" :sm="24" v-for="(item, index) in bottomInfo.bottom.links" :key="index">
                        <a :href="item.linkUrl" target="_blank">{{item.text}}</a>
                      </el-col>
                    </el-row>
                    <!-- <dl>
                              <dt>
                                <a href="javascript:;">{{bottomInfo.bottom.linksText}}</a>
                              </dt>
                              <dd v-for="(item, index) in bottomInfo.bottom.links" :key="index">
                                  <a :href="item.linkUrl" target="_blank">{{item.text}}</a>
                              </dd>
                          </dl>    -->
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="18">
              <el-row class="footerMore">
                <el-col :span="24" class="moreInfo">
                  {{bottomInfo.bottom.associatedsText}}
                </el-col>
                <el-col :xs="12" :sm="8" v-for="(item, index) in bottomInfo.bottom.associateds" :key="index">
                  <a :href="item.linkUrl" target="_blank">{{item.text}}</a>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="6" class="telephone">
              <p><i class="iconfont icon-dianhua"></i> {{bottomInfo.bottom.serviceTelText}}</p>
              <p class="phone">{{bottomInfo.bottom.serviceTel}}</p>
            </el-col>
          </el-row>
        </div>
        <div class="footerBot">
          <div class="indexContainer" style="padding:0">
            <el-row>
              <el-col :sm="19">
                <ul>
                  <li v-for="(item, index) in bottomInfo.bottom.bottomLinks" :key="index">
                    <a :href="item.linkUrl" target="_blank">{{item.text}}</a>|
                  </li>
                </ul>
              </el-col>
              <el-col :sm="5">
                <p>技术支持：爱得科技</p>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
import { getBase, getModules } from '@/api/common.js'
export default {
  name: 'Main',
  data() {
    return {
      isCollapse: false,
      logoSrc: '',
      index: 0,
      langName: '',
      languageId: '',
      activeNav: '',
      menuItem: [],
      bottomNav: [],
      bottomInfo: {
        bottom: {},
        base: {},
        languages: [],
      },
      logoUrl: '',
      drawerVisible: false,
    }
  },
  computed: {
    routerKey() {
      return this.$route.path + Math.random()
    },
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      if (_hmt) {
        if (to.path) {
          _hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
      }
      next()
    })
    this.getBase(0) // 网站基础信息
    this.getModules(this.$route.query.languageId) // 网站栏目
  },
  methods: {
    //点击搜索按钮
    searchClick() {
      this.$router.push({
        name: 'SEARCHLIST',
        query: { languageId: this.languageId },
      })
    },
    handleClose() {
      this.drawerVisible = false
    },
    innerDrawer() {
      localStorage.setItem('isShowTips', 'true')
      this.drawerVisible = false
    },
    indexClick() {
      this.$router.push({
        name: 'HOMEINDEX',
        query: { languageId: this.languageId, index: this.index },
      })
      document.title = this.bottomInfo.base.name
    },
    async getBase(val) {
      await getBase(val).then((res) => {
        const data = res.data

        // 缓存到Store
        this.$store.dispatch('saveBase', data.base)
        this.$store.dispatch('saveBottom', data.bottom)
        this.$store.dispatch('saveLanguages', data.languages)

        this.bottomInfo.base = data.base
        this.bottomInfo.bottom = data.bottom
        this.bottomInfo.languages = data.languages
        localStorage.setItem('titleSuffix', data.base.titleSuffix || '')
        this.langName = this.bottomInfo.languages[0].keyword
        this.languageId = this.bottomInfo.languages[0].id
        // const title = localStorage.getItem('name') ? localStorage.getItem('name') + '-' + localStorage.getItem('titleSuffix') :
        //               this.bottomInfo.base.name
        if (this.bottomInfo.base.titleSuffix) {
          document.title = this.bottomInfo.base.name + '-' + this.bottomInfo.base.titleSuffix
        }
        let head = document.getElementsByTagName('head')
        let meta = document.createElement('meta')
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.bottomInfo.base.keyword)
        if (localStorage.getItem('description')) {
          document.querySelector('meta[name="description"]').setAttribute('content', localStorage.getItem('description'))
        } else {
          document.querySelector('meta[name="description"]').setAttribute('content', localStorage.getItem('keywords'))
        }
        head[0].appendChild(meta)
        this.getWebtotal(this.bottomInfo.bottom.statisticalCode) // 获取网站统计
        this.getWebColor(this.bottomInfo.base.blackAndWhite) // 获取网站色调
        if (this.bottomInfo.bottom.cookieText) {
          if (!localStorage.getItem('isShowTips')) {
            this.drawerVisible = true
          }
        }
        localStorage.setItem('base', JSON.stringify(res.data.base)) //.base
        localStorage.setItem('bottom', JSON.stringify(res.data.bottom)) //.bottom
        localStorage.setItem('languages', JSON.stringify(res.data.languages)) //.languages
      })
      this.logoUrl = this.bottomInfo.base.logoUrl
    },
    getWebtotal(v) {
      var _hmt = _hmt || []
      window._hmt = _hmt // 必须把_hmt挂载到window下，否则找不到
      if (!v) return
      ;(function () {
        var hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?' + v
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })()
    },
    getWebColor(v) {
      if (+v !== 0) {
        document
          .getElementsByTagName('html')[0]
          .setAttribute('style', 'filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);-webkit-filter: grayscale(100%);')
      } else {
        document.getElementsByTagName('html')[0].setAttribute('style', '')
      }
    },
    async getModules(val) {
      this.menuItem = []
      this.bottomNav = []
      await getModules(val).then((res) => {
        for (let i in [...res.data]) {
          if (Number(res.data[i].isNav) === 1) {
            this.menuItem.push(res.data[i])
            localStorage.setItem('moduleTree', JSON.stringify(this.menuItem))
            this.$store.dispatch('saveModuleTree', this.menuItem)
            for (let v of this.menuItem) {
              v.childrens = []
              for (let k of v.childs) {
                if (Number(k.isNav) === 1) {
                  v.childrens.push(k)
                }
              }
            }
          }

          if (Number(res.data[i].isMap) === 1) {
            this.bottomNav.push(res.data[i])
            for (let v of this.bottomNav) {
              v.children = []
              for (let k of v.childs) {
                if (Number(k.isMap) === 1) {
                  v.children.push(k)
                }
              }
            }
          }
        }
      })
    },
    //收缩按钮点击展开，收起菜单
    toggleClick() {
      if (!this.isCollapse) {
        this.isCollapse = !this.isCollapse
        this.logoUrl = this.bottomInfo.base.mobileLogoUrl
      } else if (this.isCollapse) {
        this.isCollapse = !this.isCollapse
        let arr = []
        for (let i of this.menuItem) {
          arr.push(i.index)
        }
        this.openeds = arr
        this.logoUrl = this.bottomInfo.base.logoUrl
      }
    },
    langSelectChange(v) {
      let langdata
      for (let i of this.bottomInfo.languages) {
        if (v == i.name) {
          langdata = i
        }
      }
      if (langdata.linkUrl) {
        window.open(langdata.linkUrl, '_self')
      } else {
        this.langChange(langdata)
      }
    },
    langChange(data) {
      this.index++
      this.langName = data.keyword
      this.languageId = data.id
      this.$router.push({
        name: 'HOMEINDEX',
        query: { languageId: data.id, index: this.index },
      })
      this.getBase(data.id) // 网站基础信息
      this.getModules(data.id) // 网站栏目
    },
    getRouteRef() {
      return this.$refs.router
    },
    handleSelect(val) {
      localStorage.setItem('location', JSON.stringify(val.fullName))
      localStorage.setItem('name', val.name)
      if (+val.level === 1) localStorage.setItem('id', val.id)
      let keywords = val.keywords ? val.keywords : ''
      localStorage.setItem('keywords', keywords)
      let description = val.description ? val.description : ''
      localStorage.setItem('description', description)
      this.index++
      if (val.isLink == 1) {
        if (val.linkUrl) {
          window.open(val.linkUrl, '_self')
        } else {
          window.open('', '_self')
        }
      } else if (Number(val.model) === 7) {
        this.$router.push({
          name: 'ONLINEMESSAGE',
          query: { id: val.id, languageId: this.languageId, index: this.index },
        })
      } else if (Number(val.model) === 8) {
        this.$router.push({
          name: 'ONLINECONSULTATION',
          query: { id: val.id, languageId: this.languageId, index: this.index },
        })
      } else if (Number(val.model) === 10) {
        this.$router.push({
          name: 'ATTRACTINVESTMENT',
          query: { id: val.id, languageId: this.languageId, index: this.index },
        })
      } else {
        let type = 1 // 不存在选项卡
        if (Number(val.level) === 2) {
          if (val.childs.length > 0) {
            // localStorage.setItem('item', JSON.stringify(val.childs))
            type = 2
          }
        }
        this.$router.push({
          name: 'INNERPAGER',
          query: { model: val.model, id: val.id, level: val.level, type: type, languageId: this.languageId, index: this.index },
        })
      }
    },
  },
  mounted() {
    let beginTime = 0 //开始时间
    let differTime = 0 //时间差
    window.onunload = function () {
      differTime = new Date().getTime() - beginTime
      if (differTime <= 5) {
        // localStorage.removeItem('isShowTips');
        localStorage.removeItem('name')
      }
    }
    window.onbeforeunload = function () {
      beginTime = new Date().getTime()
    }
    let screenWidth = document.documentElement.clientWidth
    if (screenWidth <= 768) {
      this.isCollapse = true
    } else {
      this.isCollapse = false
    }
  },
}
</script>

<style lang="less">
@background: #f7f7f7;
.el-select-dropdown__item.selected {
  color: #d11a2e;
}
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input.is-focus .el-input__inner:hover,
.el-select .el-input.is-focus .el-input__inner:focus {
  border-color: #d11a2e;
}
.el-drawer {
  height: auto !important;
}
.el-drawer__wrapper {
  z-index: 9999;
}
.el-drawer {
  font-size: 14px;
  line-height: 24px;
  color: #333;
  padding: 0 20px;
  background-color: rgba(255, 255, 255, 0.8);
  .cookieButton {
    padding: 10px 60px;
    color: #fff;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    margin-top: 20px;
    background: #d11a2e;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 500;
  }
  .cookieButton:hover {
    background: #d11a2e;
    border: 1px solid #dcdfe6;
  }
}

//左侧菜单
.imgShow {
  height: 100%;
  &.fold {
    width: none;
    .el-scrollbar {
      display: none;
    }
  }
}
.logo {
  cursor: pointer;
}
.phonelogo {
  height: 60px;
  width: 137px;
  cursor: pointer;
}
.phonelogo img {
  height: 100%;
}
.el-aside {
  overflow: hidden;
}
/deep/ .el-menu-item,
/deep/ .el-submenu__title {
  z-index: 999999;
}
.pageMenulist {
  padding: 0;
  text-align: left;
  transition: left 0.4s ease;
  display: -ms-flexbox;
  display: flex;
  height: 60px;
  width: 100% !important;
  position: fixed;
  z-index: 55;
  background: @background;

  //选择语言
  .langMain {
    background: none;
    margin-top: 0;
    text-align: right;
    float: right;
    position: relative;
    right: 0;
    //小屏幕选择语言
    .langSmallMain {
      display: block;
      width: 80px;
      float: right;
      margin: 13px 5px 0 0;
      .el-select .el-input.is-focus .el-input__inner,
      .el-select .el-input.is-focus .el-input__inner:hover,
      .el-select .el-input.is-focus .el-input__inner:focus {
        border-color: #d11a2e;
      }
    }

    .langMainBtn {
      width: 40px;
      height: 60px;
      margin-left: 0;
    }
    ul.langMenuList {
      width: auto;
      padding: 0 5px;
      margin: 0 0 0 5px;
      box-sizing: border-box;
      display: none;
      border-left: 1px solid #e0e0e0;
      li {
        display: inline-block;
        padding-top: 0;
        a {
          background: none;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          margin: 0 5px;
          padding: 0 6px;
          width: 40px;
        }
        a:hover {
          background: #fff;
          border: 1px solid #d11a2e;
          color: #d11a2e;
        }
      }
    }
    .langName {
      display: none;
      border: 1px solid #d11a2e;
      border-radius: 4px;
      background: #fff;
      a {
        color: #d11a2e;
        padding: 0 6px;
      }
    }
  }
  .el-scrollbar {
    width: 250px;
    position: fixed;
    right: 0;
    top: 60px;
    height: 300px;
    .el-scrollbar__wrap {
      overflow-y: scroll !important;
      overflow-x: hidden !important;
    }
    .el-menu {
      background: @background;
      border: 0;
      padding: 0 10px;
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
      min-height: 400px;
      max-height: 100%;
      height: 85%;
    }
    .el-submenu.is-active .el-submenu__title,
    .el-submenu__title,
    .el-menu-item {
      text-align: left;
      border-bottom: 1px solid #ccc;
      padding: 0 !important;
      span {
        font-size: 16px;
        font-weight: 400;
        display: inline-block;
        height: 45px;
        margin-top: -2px;
        border-bottom: 1px solid #d11a2e;
        i {
          display: inline-block;
          background: #333;
          border-radius: 5px;
          width: 5px;
          height: 5px;
          margin-right: 8px;
        }
      }
    }

    .el-submenu .el-menu-item {
      height: 32px;
      line-height: 32px;
      padding-left: 16px !important;
      padding-top: 5px;
      text-align: left;
      color: #757575;
    }
    .el-submenu .el-submenu__title:hover {
      background: none;
      span {
        color: #d11a2e;
        font-size: 16px;
        font-weight: 400;
        display: inline-block;
        height: 45px;
        margin-top: -2px;
        border-bottom: 1px solid #d11a2e;
        i {
          background: #d11a2e;
        }
      }
    }
    .el-menu-item,
    .el-submenu__title {
      height: 45px;
      line-height: 45px;
    }
    .el-menu-item:focus,
    .el-menu-item:hover {
      background: none;
      color: #d11a2e;
    }
  }
}
//左侧菜单 end
.pageContainer {
  width: 100%;
  display: inline-block;
  flex: 1;
  padding-left: 0;
  padding-top: 60px;
  &.fold {
    padding-left: 0 !important;
    padding-top: 60px;
    transition: padding-left 0.4s ease;
  }
}
//正文外框 end

//通用正文
.el-main {
  padding: 0;
}
.indexContainer {
  width: 95%;
  height: auto;
  margin: 0 auto;
  padding-top: 20px;
}
.indexTitle {
  margin: 50px 0 50px;
  display: inline-block;
  .indexTitleMain {
    text-align: center;
    padding: 0;
    margin: 0;
    h3 {
      font-size: 18px;
      font-weight: normal;
      padding: 0;
      margin: 0;
      display: inline-block;
      line-height: 40px;
    }
    h4 {
      color: #999;
      font-size: 10px;
      padding: 0;
      margin: 0;
      display: inline-block;
      font-weight: normal;
    }
  }
}
//通用正文end
//底部
.el-footer {
  background: @background;
  width: 100%;
  margin: 0 auto;
  margin-top: 40px;
  height: auto !important;
  padding: 0;
  .footer {
    width: 100%;
    .footerMenu {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      border-right: none;
      dl {
        width: 25%;
        padding: 0 10px;
        text-align: left;
        line-height: 22px;
        display: inline-block;
        box-sizing: border-box;
        margin: 6px 0;
        dt {
          font-size: 14px;
          font-weight: bold;
          a {
            color: #333;
          }
          a:hover {
            color: #d11a2e;
            text-decoration: underline;
          }
        }
        dd {
          font-size: 12px;
          font-weight: normal;
          margin: 0;
          a {
            color: #666666;
          }
          a:hover {
            color: #d11a2e;
            text-decoration: underline;
          }
        }
      }
    }
    .linkList {
      border: 0;
      padding: 0;
      display: inline-block;
      text-align: left;
      line-height: 32px;
      .linksText {
        font-size: 16px;
        font-weight: bold;
      }
      dl {
        width: 100%;
      }
    }
    .footerMore {
      padding-top: 30px;
      text-align: left;
      line-height: 32px;
      font-size: 12px;
      .moreInfo {
        font-size: 16px;
        font-weight: bold;
      }
      a {
        color: #666666;
      }
      a:hover {
        color: #d11a2e;
        text-decoration: underline;
      }
    }
  }
  .footerWx {
    padding-top: 0;
    display: inline-block;
    p {
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }
    img {
      width: 120px;
    }
  }
  .telephone {
    color: #d11a2e;
    font-size: 20px;
    line-height: 36px;
    padding-top: 50px;
    i {
      font-size: 22px;
      font-weight: bold;
    }
    p {
      margin: 0;
      text-align: center;
    }
    .phone {
      font-size: 24px;
      font-weight: bold;
    }
  }
  .footerBot {
    background: #d11a2e;
    line-height: 28px;
    color: #fff;
    text-align: center;
    font-size: 14px;
    ul {
      padding: 0;
      margin: 0;
      li {
        display: inline-block;
        color: #fff;
        a {
          color: #fff;
          line-height: 24px;
          padding: 0 10px;
        }
      }
      li:first-child a {
        padding: 0 10px 0 0;
      }
    }
    p {
      margin: 0;
      padding: 0;
      text-align: center;
    }
  }
}
//底部end

@media (min-width: 1024px) {
  .imgShow {
    &.fold {
      width: 70px !important;
    }
  }
  .logo {
    display: block;
  }
  .phonelogo {
    display: none;
  }
  .pageMenulist {
    width: 320px !important;
    height: 100%;
    .logo {
      // background: url('./assets/logo.jpg') no-repeat 100% ;
      height: 140px;
      width: 100%;
      transition: width 0.4s ease;
    }

    .langMain {
      display: block;
      background: #ebebeb;
      width: 70px;
      height: 100%;
      text-align: center;
      float: left;
      .langMainBtn {
        height: auto;
      }
      .langSmallMain {
        display: none;
      }
      .langName {
        margin-bottom: 10px;
        display: inline-block;
      }
      ul.langMenuList {
        width: 100%;
        padding: 0 18px;
        margin: 0;
        box-sizing: border-box;
        display: inline-block;
        li {
          width: 100%;
          padding-top: 5px;
          a {
            background: #f7f7f7;
            border-radius: 4px;
            display: inline-block;
            margin: 5px 0;
            width: auto;
          }
          a:hover {
            background: #fff;
            border: 1px solid #d11a2e;
            color: #d11a2e;
          }
        }
        li:first-child {
          border-top: 1px solid #ccc;
        }
      }
    }
    .el-scrollbar {
      width: 250px;
      position: relative;
      top: 0;
      height: 80%;
    }
  }
  //左侧菜单 end
  .pageContainer {
    overflow: auto;
    width: 100%;
    display: inline-block;
    flex: 1;
    padding-left: 320px;
    padding-top: 0px;
    &.fold {
      padding-top: 0px;
      padding-left: 70px !important;
      transition: padding-left 0.4s ease;
    }
  }
}
@media (max-width: 1023px) {
  .logo {
    display: none;
  }
  .phonelogo {
    display: block;
  }
}
@media (max-width: 768px) {
  //
}
@media (min-width: 768px) {
  .el-drawer {
    font-size: 20px;
    line-height: 36px;
    .cookieButton {
      font-size: 20px;
      margin-bottom: 50px;
    }
  }
  .indexTitle {
    .indexTitleMain {
      h3 {
        font-size: 26px;
      }
      h4 {
        font-size: 20px;
      }
    }
  }
  .el-footer .footer .footerMenu {
    dl {
      width: 20%;
    }
    dt {
      font-size: 16px;
    }
  }
  .el-footer .footerWx {
    text-align: center;
    padding: 0 0 0;
    display: block;
  }
  .el-footer .telephone {
    p {
      text-align: left;
    }
  }
  .el-footer .footer .linkList {
    border: 0;
    padding: 0 30px;
    display: block;
    box-sizing: border-box;
    line-height: 22px;
    a {
      font-size: 12px;
    }
    dl {
      width: 100%;
    }
  }
  .el-footer {
    .footerBot {
      line-height: 40px;
      ul {
        text-align: left;
        li {
          a {
            line-height: 40px;
          }
        }
      }
      p {
        text-align: right;
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .indexContainer {
    max-width: 700px;
    width: 100%;
  }
  .el-footer .telephone .phone {
    font-size: 20px;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .indexContainer {
    max-width: 780px;
    width: 100%;
  }
  .el-footer .telephone .phone {
    font-size: 24px;
  }
}
@media only screen and (min-width: 1200px) {
  .indexContainer {
    max-width: 960px;
    width: 100%;
  }
  .el-footer .telephone .phone {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/Main.vue